module.exports = __webpack_public_path__ + "src/assets/img/weight.df923244.png";